<template>
  <AdmPanel>
    <h2 slot="header_title">报告库</h2>
    <!-- 筛选条件 -->
    <FilterBar slot="header_buttons" :value="conditions" :condition="options.filter_rules" @search="changeQuery">
      <span class="adm-buttons">
        <iv-button type="info" @click="changeQuery()" :disabled="loader[REPORT + 'fetch']"> <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" />查询 </iv-button>
        <!-- 上传报告按钮 -->
        <iv-button v-rbac-allow="['carbonReport', 'upload']" type="primary" class="upload-report-btn"
          @click="isShowUploadBox = true">
          <iv-icon type="upload" /> 上传报告 </iv-button>
      </span>
    </FilterBar>
    <template v-if="loader[PUBLIC_SENTIMENT + '_fetch']">
      <p class="text-center">加载中...</p>
    </template>
    <template v-else>
      <p v-if="reportRepoList.data.length <= 0" class="text-center">
        <EmptyData>
          <div class="nextPage" slot="emptyBtn">
            <iv-button @click="pageChanged">重新获取</iv-button>
          </div>
        </EmptyData>
      </p>
      <div class="adm-list" v-else>
        <div v-for="(item, index) in reportRepoList.data" class="adm-content-item" :key="index">
          <div class="adm-content-item-desc">
            <p class="item-report-title">{{ item.title }}</p>
            <div class="item-report-desc">
              <span>{{ `公司名称：${item.companyInfo.companyName}` }}</span>
              <span>{{ `报告类型：${getReportTypeName(item.reportType)}` }}</span>
              <span>{{ `发布于：${item.postTime}` }}</span>
            </div>
          </div>
          <div class="adm-content-item-operation">
            <iv-button v-rbac-allow="['carbonReport', 'download']" type="primary" @click="handleReporterDownload(item)">下载</iv-button>
            <iv-button v-rbac-allow="['carbonReport', 'delete']" type="primary" @click="handleReporterDelect(item)">删除</iv-button>
          </div>
        </div>
      </div>
    </template>
    <!-- <template v-if="reportRepoList.data.length > 0">
            <div class="nextPage">
                <iv-button @click="pageChanged">下一批</iv-button>
            </div>
        </template> -->
    <template v-if="reportRepoList.last_page > 1">
      <div slot="footer" class="pull-right">
        <iv-page @on-change="pageChanged" :current="reportRepoList.current_page" :page-size="10" show-elevator show-total :total="reportRepoList.total"> </iv-page>
      </div>
    </template>
    <iv-modal :mask-closable="false" title="上传报告" width="450" :closable="false" v-model="isShowUploadBox" @on-cancel="isShowUploadBox = false">
      <iv-form :model="formValidate" :rules="ruleValidate" ref="formValidate" label-position="top" inline>
        <iv-form-item label="请选择公司" prop="stockCode">
          <iv-select clearable filterable v-model="formValidate.stockCode" placeholder="请选择公司" style="width:200px">
            <iv-option v-for="item in options.AllCompanys" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
          </iv-select>
        </iv-form-item>
        <iv-form-item label="请选择年份" prop="year">
          <iv-select v-model="formValidate.year" placeholder="年份" style="width:100px">
            <iv-option v-for="item in options.year" :key="item.id" :value="item.id">{{ item.name }}</iv-option>
          </iv-select>
        </iv-form-item>
        <br />
        <iv-form-item prop="reportType">
          <iv-radio-group v-model="formValidate.reportType">
            <iv-radio label="0">年报</iv-radio>
            <iv-radio label="1">社报</iv-radio>
            <iv-radio label="3">专项</iv-radio>
          </iv-radio-group>
        </iv-form-item>
        <br />
        <iv-form-item label="选择文件" prop="file">
          <iv-upload ref="upload" action="#" :auto-upload="false" :multiple="false" :before-upload="handleBeforeUpload" accept=".pdf">
            <iv-button icon="ios-cloud-upload-outline">选择报告</iv-button>
          </iv-upload>
          <span class="upload-file-name">{{ this.formValidate.fileName }}</span>
          <iv-button type="primary" v-show="this.formValidate.fileName" @click="removeUploadFile">删除</iv-button>
        </iv-form-item>
        <br />
        <iv-form-item label="发布时间" prop="publishDate">
          <iv-date-picker type="date" placeholder="请选择日期" v-model="formValidate.publishDate" format="yyyy/MM/dd"></iv-date-picker>
        </iv-form-item>
        <br />
        <iv-form-item label="替换已有报告" prop="replace">
          <iv-switch v-model="formValidate.replace" size="large" true-value="1" false-value="0">
            <span slot="true">On</span>
            <span slot="false">Off</span>
          </iv-switch>
        </iv-form-item>
      </iv-form>
      <iv-button type="text" size="large" slot="footer" @click="isShowUploadBox = false">取消</iv-button>
      <iv-button type="primary" size="large" slot="footer" @click="handleUpload" :loading="loader[REPORT + 'upload']">上传</iv-button>
    </iv-modal>
  </AdmPanel>
</template>

<script>
import PublicSentimentModel from "@/models/PublicSentimentModel";
import CarbonReportModel from "@/models/CarbonReportModel";
import CarbonCompanyModel from "@/models/CarbonCompanyModel";
import CarbonIndustryModel from "@/models/CarbonIndustryModel";
import ModelMixin from "@/mixins/Model.mixin";
import StatusMixin from "@/mixins/Status.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import { conditioner, carbon_years, getProductYear } from "@/utils/";
import FilterBar from "@/components/FilterBar_X2";
import OpinionItem from "@/components/OpinionItem";
import EmptyData from "@/components/EmptyData";
import Fecha from "@/utils/type/Fecha";
import cookies from "js-cookie";

const PUBLIC_SENTIMENT = PublicSentimentModel.ModelName; // remove '$'
const ModelName = PUBLIC_SENTIMENT;
const COMPANY = CarbonCompanyModel.ModelName;
const REPORT = CarbonReportModel.ModelName;
const INDUSTRY = CarbonIndustryModel.ModelName;

const OSS = require("ali-oss");

const _years = carbon_years().map(year => ({ ...year, title: year.name }));
let _options = {
  year: _years,
  industry: [],
  companys: [],
  AllCompanys: [],
  targetType: [
    { id: "0", name: "定量" },
    { id: "1", name: "定性" }
  ],
  inputTab: [
    { id: "", name: "不限" },
    { id: "0", name: "年报" },
    { id: "1", name: "社报" },
    { id: "3", name: "专项" }
  ]
};

const filter_rules = [
  { name: "year", type: "Select", options: _years, title: "年份", default: "", placeholder: "年份" },
  { name: "industryId", type: "Select", options: [], title: "行业", default: "", placeholder: "行业", clearable: true, style: { width: "90px" } },
  { name: "stockCode", type: "Select", options: [], title: "公司", default: "", placeholder: "公司", filterable: true, clearable: true, style: { width: "150px" } },
  { name: "reportType", type: "Select", options: _options.inputTab, title: "报告类型", default: "", placeholder: "报告类型", style: { width: "90px" } }
];

const options = {
  filter_rules,
  ..._options
};

const _conditioner = conditioner(
  {
    //   time  : {type: Fecha.format, default: undefined},
    limit: { type: Number, default: 10 },
    year: { type: String, default: "" },
    industryId: { type: Number, default: "" },
    stockCode: { type: String, default: "" },
    inputTab: { type: String, default: "" },
    reportType: { type: String, default: "" }
    // _searchby        : {type: String, default: "industryId"}
  },
  {
    //   time  : {type: Fecha.format, default: undefined},
    limit: { type: Number, default: 10 },
    year: { type: Number, default: () => getProductYear() },
    industryId: { type: Number, default: "" },
    stockCode: { type: String, default: "" },
    inputTab: { type: String, default: "" },
    reportType: { type: String, default: "" }
    // _searchby        : {type: String, default: "industryId"}
  }
);

export default {
  name: "report",
  components: {
    FilterBar,
    OpinionItem,
    EmptyData
  },
  mixins: [
    LoaderMixin(PUBLIC_SENTIMENT + "_fetch", REPORT + "fetch", REPORT + "upload", INDUSTRY),
    StatusMixin("report")(["loading"]),
    ModelMixin({
      contact,
      models: [PublicSentimentModel, CarbonCompanyModel, CarbonReportModel, CarbonIndustryModel]
    })
  ],
  data() {
    return {
      conditions: _conditioner.default(),
      ModelName,
      PUBLIC_SENTIMENT,
      REPORT,
      reportRepoList: {
        data: [],
        last_page: 0,
        current_page: 1,
        limit: 10
      },
      options,
      source: {},
      isShowUploadBox: false,
      formValidate: {
        stockCode: "",
        year: getProductYear(),
        reportType: "0",
        replace: "0",
        publishDate: "",
        file: "",
        fileName: ""
      },
      ruleValidate: {
        stockCode: [{ required: true, message: "请选择企业", trigger: "change" }],
        year: [{ required: true, message: "请选择年份", trigger: "change", type: "number" }],
        file: [{ required: true, message: "请选择文件", trigger: "change", type: "object" }],
        reportType: [{ required: true, message: "请选择报告类型", trigger: "change" }]
      },
      client: null
    };
  },
  async created() {
    const { query, params } = this.$route;
    let conditions = _conditioner.serialize({ ...query, ...params }); //处理成支持UI的格式

    this.refreshAllCompanys();

    // const yearlist = await this.getYear() || []
    // this.renderFilterBar("year", yearlist)
    // conditions.year = defaultVal(conditions.year, new Date().getMonth() > 7 ? new Date().getFullYear() : new Date().getFullYear() - 1)

    const industries = (await this.refreshIndustry(conditions.year)) || [];
    this.renderFilterBar("industryId", industries);
    // conditions.industryId = defaultVal(conditions.industryId, industries[0].id)

    const companys = (await this.refreshCompanys()) || [];
    this.renderFilterBar("stockCode", companys);
    // conditions.stockCode = conditions._searchby == "stockCode" ? defaultVal(conditions.stockCode, companys[0].id) : ""

    this.conditions = conditions;
    this.$nextTick(() => {
      this.refresh(conditions);
    });

    console.log("created... see options", this.options);
  },
  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      const { query, params } = to;
      this.conditions = {
        ..._conditioner.default(),
        ..._conditioner.serialize({ ...query, ...params }) //处理成支持UI的格式
      };
      this.refresh();
    });
    next();
  },
  methods: {
    async refresh(query = this.conditions, page) {
      this.$$loading(PUBLIC_SENTIMENT);
      this.fetchReportList(undefined, page);
      this.$$loaded(PUBLIC_SENTIMENT);
    },
    // 下载按钮
    handleReporterDownload(item) {
      console.log("handleReporterDownload", item);
      window.open(item.savePath, "_blank");
    },
    // 删除按钮
    async handleReporterDelect(item) {
      console.log("handleReporterDownload", item);
      const res = await this.$$del(REPORT, item.id);
      if (res.code == 202) {
        this.$$success("删除成功");
        this.reportRepoList.data = this.reportRepoList.data.filter(_item => {
          if (_item.id != item.id) {
            return _item;
          }
        });
        this.$forceUpdate();
      } else {
        this.$$error("删除失败", res.msg);
      }
    },
    async refreshIndustry(year) {
      const industry = await this.$$fetch(INDUSTRY, { year: year });
      if (industry) this.options.industry = industry.data.map(item => ({ ...item, name: item.industry }));
      return this.options.industry;
    },
    async refreshCompanys(query, industryId = this.conditions.industryId) {
      // 获取全部公司时
      if (industryId == -1) {
        industryId = "";
      }
      const res = await this.$$fetch(COMPANY, { stockCode: query, industryId, allTab: 1 });
      return (this.options.companys = res.data.map(item => ({ id: item.stockCode, name: item.stockCode + " " + item.abbreviation })));
    },
    async refreshAllCompanys() {
      this.options.AllCompanys = await this.refreshCompanys("", -1);
    },
    renderFilterBar(fieldName, val, defaults) {
      const fieldset = this.options.filter_rules.find(fieldset => fieldset.name === fieldName);
      fieldset.options = val;
    },
    changeQuery(query = this.conditions, params = this.$route.params) {
      this.$router.push({
        name: this.$route.name,
        query: { ..._conditioner.parse(query), offset: 0 },
        params: params
      });
    },
    // pageChanged(page){
    //     this.refresh(undefined, page - 1)
    // },
    pageChanged(page) {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: (page - 1) * _conditioner.parse(this.conditions).limit }, params: this.$route.params });
    },
    // 获取list
    async fetchReportList(query = this.conditions, page = this.reportRepoList.current_page - 1) {
      const _query = {
        offset: page * this.reportRepoList.limit,
        limit: this.reportRepoList.limit,
        stockCode: "",
        // industryId: 1,
        reportType: 0,
        year: 2019,
        ...query
      };
      const res = await this.$$fetch(REPORT, { ..._query, type: "all" });
      console.log("res", res);
      this.reportRepoList.data = res.data;
      this.reportRepoList.total = res.total;
      this.reportRepoList.current_page = _query.offset ? _query.offset / _query.limit + 1 : 1;
      this.reportRepoList.last_page = this.reportRepoList.total / this.reportRepoList.limit;
      console.log("reportRepoList", this.reportRepoList);
      return res;
    },
    getReportTypeName(id) {
      let res = "";
      this.options.inputTab.forEach(item => {
        if (item.id == id) {
          res = item.name;
        }
      });
      return res || "不限";
    },
    async handleUpload() {
      const validate = await this.$refs.formValidate.validate();
      if (!validate) {
        this.$$warning("表单验证不通过，请继续填写。");
        return;
      }
      let publishDate = Fecha.format(this.formValidate.publishDate, "YYYY-MM-DD 00:00:00");

      this.$$loading(REPORT + "upload");
      this.$ivLoading.start();
      const uploader = await this.$$active(REPORT, "ossSetting", this.formValidate);
      if (Error.isError(uploader)) {
        this.$$loaded(REPORT + "upload");
        this.$ivLoading.error();
        return;
      }
      let region = uploader.data.OSS_URL ? uploader.data.OSS_URL.split(".")[0] : "";
      let url = `${location.protocol}//${uploader.data.BUCKET_NAME}.${uploader.data.OSS_URL}/${uploader.data.path}`;

      let ossConfig = {
        region: region,
        accessKeyId: uploader.data.accessKeyId,
        accessKeySecret: uploader.data.accessKeySecret,
        bucket: uploader.data.BUCKET_NAME,
        stsToken: uploader.data.securityToken
      };
      this.client = new OSS(ossConfig);
      let checkpoint;
      /** 上传 **/
      const fileObject = this.formValidate.file;
      const objectKey = this.formValidate.fileName;

      let hasFile = true
      try{
        const res = await contact.remote().sync({ url, method: "HEAD" })
        console.log("HEAD",res)
      }catch(e){
        hasFile = false
        console.warn("HEAD", e)
      }

      if(!hasFile){ //没有文件在云端，走上传规则
        try{
          // cookies.set(`file::${objectKey}`, checkpoint);
          checkpoint = localStorage.getItem(`file::${objectKey}`)
          checkpoint = JSON.parse(checkpoint)
        }catch(e){
          console.error(e)
        }
        this.$$uploader = fileObject;
        let result = await this.client.multipartUpload(uploader.data.path, fileObject, {
          progress: function(p, checkpoint) {
            try{
              // cookies.set(`file::${objectKey}`, checkpoint);
              localStorage.setItem(`file::${objectKey}`, JSON.stringify(checkpoint))
            }catch(e){
              console.error(e)
            }
          },
          checkpoint,
          mime: fileObject.type
          // meta: { ...this.formValidate, publishDate }, //可选
        });

        if (result.res.statusCode == 200) {
          let savePath = result.res.requestUrls[0];
          localStorage.removeItem(`file::${objectKey}`)
          this.savePath(savePath, publishDate);
        } else {
          this.$ivLoading.error();
          this.$$info("上传失败，请重试");
        }
      }else{ // 有文件在云端，直接走发布
        this.savePath(url, publishDate);
      }
      this.$$loaded(REPORT + "upload");
    },
    async savePath(savePath, publishDate) {
      const res = await this.$$active(REPORT, "uploadRecord", { ...this.formValidate, savePath, postTime: publishDate });
      if (res.code == 201) {
        this.$ivLoading.finish();
        this.$$success("上传成功");
        this.isShowUploadBox = false;
        this.initFormValidate();
      } else {
        this.$ivLoading.finish();
        this.$$info("上传失败，请重试");
      }
    },
    handleBeforeUpload(file) {
      console.log("handleBeforeUpload...", file);
      this.formValidate.file = file;
      this.formValidate.fileName = file.name;
      //阻止自动上传
      return false;
    },
    removeUploadFile() {
      this.formValidate.file = "";
      this.formValidate.fileName = "";
    },
    initFormValidate() {
      this.formValidate = {
        company: "000001",
        year: "2021",
        reportType: "0",
        replace: "0",
        publishDate: "",
        file: "",
        fileName: ""
      };
    }
  },
  watch: {
    "conditions.industryId": {
      async handler(newVal, oldVal) {
        let companys = await this.refreshCompanys("", newVal);
        this.renderFilterBar("stockCode", companys);
      }
    },
    'conditions.year': {
      async handler (newVal, oldVal) {
        if (oldVal) {
          const industries = await this.refreshIndustry(newVal);
          this.renderFilterBar("industryId", industries);
        }
      }
    },
    isShowUploadBox(val) {
      if (val) {
        this.$$uploader = null;
        // this.formValidate = {
        //   stockCode: "",
        //   year: 2020,
        //   reportType: "0",
        //   replace: "0",
        //   publishDate: "",
        //   file: "",
        //   fileName: ""
        // };
        this.$nextTick(() => this.$refs.formValidate.resetFields());
      } else if (this.$$uploader) {
        this.$$loaded(REPORT + "upload");
        this.$ivLoading.finish();
        // this.$$uploader.cancel('用户手动取消')
        this.client.cancel();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  padding: 0px 10px;
  border-bottom: solid 1px #ddd;
  .upload-report-btn {
    position: absolute;
    right: 10px;
    bottom: 20px;
  }
  form {
    display: inline-block;
    margin-right: 30px;
  }
  span {
    margin-bottom: 20px;
  }
}
.adm-panel__tools {
  margin-bottom: -50px;
}
.adm-list {
  > * {
    border-bottom: solid 1px #ddd;
    list-style: none;
  }
  .adm-content-item {
    width: 100%;
    height: 71px;
    border-bottom: solid 1px #ddd;
    box-sizing: border-box;
    display: flex;
    .adm-content-item-desc {
      padding: 10px 20px;
      flex: 1;
      .item-report-title {
        margin-bottom: 15px;
        color: #000;
      }
      .item-report-desc {
        span {
          margin-right: 20px;
        }
      }
    }
    .adm-content-item-operation {
      height: 71px;
      line-height: 71px;
      button {
        margin-right: 10px;
      }
    }
  }
}
.upload-file-name {
  margin-left: 10px;
  width: 290px;
  line-height: 12px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.upload-file-remove-btn {
  line-height: 12px;
}

.nextPage {
  margin: 15px 0;
  display: flex;
  justify-content: center;
  text-align: center;
  button {
    width: 200px;
  }
}
</style>
